import { Box, Theme, useTheme } from '@mui/material';
//| import { Theme } from '@mui/material/styles';
import { makeStyles, createStyles } from '@mui/styles';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import type { RootState } from '../../store/config/types';
import ColoredCardWithTotals from './ColoredCardWithTotals';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    coloredCard: {
      marginBottom: '1rem',
      display: 'flex',
    },
    secondDivider: {
      margin: '1rem 0',
    },
  })
);



const mapStateToProps = (state: RootState) => ({
  payments: state.payments,
});
const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const ColoredCardsWithTotals = ({ payments }: PropsFromRedux) => {
  const classes = useStyles(useTheme());
  return (
    <>
      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <ColoredCardWithTotals
          className={classes.coloredCard}
          color="warning"
          description="Links de 1 uso pendientes"
          pesosAmount={
            payments.paymentsTotals.oneTimeOnlyTotals
              ? payments.paymentsTotals.oneTimeOnlyTotals.uruguayanPesoAmount
              : 0
          }
          usdAmount={
            payments.paymentsTotals.oneTimeOnlyTotals
              ? payments.paymentsTotals.oneTimeOnlyTotals.dollarAmount
              : 0
          }
          pesosCount={
            payments.paymentsTotals.oneTimeOnlyTotals
              ? payments.paymentsTotals.oneTimeOnlyTotals.uruguayanPesoCount
              : 0
          }
          usdCount={
            payments.paymentsTotals.oneTimeOnlyTotals
              ? payments.paymentsTotals.oneTimeOnlyTotals.dollarCount
              : 0
          }
        />
      </Box>
      <ColoredCardWithTotals
        className={classes.coloredCard}
        color="success"
        description="Links de 1 uso aprobados"
        pesosAmount={
          payments.paymentsTotals.oneTimeOnlyTotals
            ? payments.paymentsTotals.oneTimeOnlyTotals.uruguayanPesoAmount
            : 0
        }
        usdAmount={
          payments.paymentsTotals.oneTimeOnlyTotals
            ? payments.paymentsTotals.oneTimeOnlyTotals.dollarAmount
            : 0
        }
        pesosCount={
          payments.paymentsTotals.oneTimeOnlyTotals
            ? payments.paymentsTotals.oneTimeOnlyTotals.uruguayanPesoCount
            : 0
        }
        usdCount={
          payments.paymentsTotals.oneTimeOnlyTotals
            ? payments.paymentsTotals.oneTimeOnlyTotals.dollarCount
            : 0
        }
      />
      <ColoredCardWithTotals
        className={classes.coloredCard}
        color="error"
        description="Pagos fallidos"
        pesosAmount={
          payments.paymentsTotals.rejectedTotals
            ? payments.paymentsTotals.rejectedTotals.uruguayanPesoAmount
            : 0
        }
        usdAmount={
          payments.paymentsTotals.rejectedTotals ? payments.paymentsTotals.rejectedTotals.dollarAmount : 0
        }
        pesosCount={
          payments.paymentsTotals.rejectedTotals
            ? payments.paymentsTotals.rejectedTotals.uruguayanPesoCount
            : 0
        }
        usdCount={
          payments.paymentsTotals.rejectedTotals ? payments.paymentsTotals.rejectedTotals.dollarCount : 0
        }
      />
    </>
  );
};

export default connector(ColoredCardsWithTotals);
